export const formatPhone = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');
  const regex = /^55(\d{2})(\d{5})(\d{4})$/;
  const match = regex.exec(cleaned);


  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phone;
};

export const mascaraTelefone = (valor: string): string => {
  // (12) 93456-7890 - celular (9 dígitos)
  // ou
  // (12) 1234-5678 - fixo (8 dígitos)
  const valorLimpo = valor.replace(/\D/g, '');

  if (valorLimpo.length === 11) {
    // Celular: (XX) 9XXXX-XXXX
    return valorLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (valorLimpo.length === 10) {
    // Fixo: (XX) XXXX-XXXX
    return valorLimpo.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }


  return valorLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

};
